var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workerorderindex",
    on: {
      "scroll": _vm.scorllBottom
    }
  }, [_c('top'), _vm._v(" "), _c('div', {
    staticClass: "nav"
  }, [_c('router-link', {
    staticStyle: {
      "color": "rgb(31, 55, 61)"
    },
    attrs: {
      "to": _vm.urlb
    }
  }, [_c('span', {
    on: {
      "click": _vm.hisback
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('span', {
    staticClass: "navbread"
  }, [_vm._v(_vm._s('>' + _vm.questionclass))]), _vm._v(" "), _c('router-link', {
    staticClass: "btna color",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "to": {
        path: '/myorder'
      }
    }
  }, [_vm._v("我的工单")])], 1), _vm._v(" "), (_vm.orderdata.length == 0 && _vm.contentis && _vm.noGetListShow) ? _c('div', {
    staticClass: "noGetList"
  }, [_vm._v("\n    您还未提交工单哦~\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contentis),
      expression: "contentis"
    }],
    staticClass: "content"
  }, _vm._l((_vm.orderdata), function(item, index) {
    return _c('p', [_c('span', {
      staticClass: "tishi",
      attrs: {
        "id": 'd' + index
      }
    }, [_c('span', [_vm._v(_vm._s(item.orderName))]), _vm._v(" "), _c('a')]), _vm._v(" "), (item.orderName.length >= 6) ? _c('span', {
      staticStyle: {
        "width": "100px"
      },
      on: {
        "mouseenter": function($event) {
          $event.stopPropagation();
          _vm.block(index)
        },
        "mouseleave": function($event) {
          $event.stopPropagation();
          _vm.none(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.reversedMessage(item.orderName)))]) : _c('span', {
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(item.orderName))]), _vm._v(" "), _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(item.processInstanceId))]), _vm._v(" "), (item.status == 10) ? _c('span', {
      staticClass: "cls"
    }, [_vm._v("已完成")]) : _c('span', {
      staticClass: "cls orange"
    }, [_vm._v("处理中")]), _vm._v(" "), _c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(item.startTime))]), _vm._v(" "), _c('span', {
      staticClass: "im",
      on: {
        "click": function($event) {
          _vm.sessitem(item.orderName)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/workdetail?',
          query: {
            'id': item.processInstanceId
          }
        }
      }
    }, [_c('img', {
      staticStyle: {
        "display": "block",
        "margin-top": "15px"
      },
      attrs: {
        "src": require("../../assets/workorder/arrow.png")
      }
    })])], 1)])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loginis),
      expression: "loginis"
    }],
    staticClass: "login"
  }, [_c('p', [_vm._v("手机号为查看单据处理结果的依据")]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "phonenumber",
    attrs: {
      "placeholder": "请输入手机号码"
    },
    on: {
      "blur": _vm.phonego
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.phoneis))])], 1), _vm._v(" "), _c('div', {
    staticClass: "mat"
  }, [_c('span', [_vm._v("随机码")]), _vm._v(" "), _c('el-input', {
    staticClass: "verify",
    attrs: {
      "placeholder": "短信随机码"
    },
    model: {
      value: (_vm.verify),
      callback: function($$v) {
        _vm.verify = $$v
      },
      expression: "verify"
    }
  }), _vm._v(" "), (_vm.verifyis) ? _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    on: {
      "click": _vm.verifygo
    }
  }, [_vm._v("获取随机码")]) : _c('span', {
    staticClass: "verifybtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    })
  }, [_vm._v(_vm._s(_vm.timesecond + "s"))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.veris))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "color verbtn",
    style: ({
      backgroundColor: _vm.boxBodyColor
    }),
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verifyconfirm
    }
  }, [_vm._v("下一步")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d9b086","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workorder/myorder.vue
// module id = 9Nd4
// module chunks = 1